module.exports = __webpack_public_path__ + "img/Eduzz-10-en.7d2b4db7.png";